import axios from "axios";
import React, { useEffect, useMemo, useState } from "react";
import { useNavigate } from "react-router";
import Actions from "../../components/Common/Actions";
import AntdBreadcrumbs from "../../components/Common/Breadcrumbs/AntdBreadcrumbs";
import FilledButton from "../../components/Common/Buttons/FilledButton";
import ListPageLayout from "../../components/Layout";
import Deletepopup from "../../components/Modal/Deletepopup";
import usePageChange from "../../components/Utils/hooks/usePageChange";
import usePaginatedData from "../../components/Utils/hooks/usePaginatedData";

const ViewServiceCategory = () => {
  const navigate = useNavigate();
  // Delete state
  const [deleteId, setDeleteId] = useState("");
  const [showDelete, setShowDelete] = useState(false);

  // Pagination
  const { records, totalCount, pagination, setPagination, fetchData } =
    usePaginatedData({
      apiUrl: `${process.env.REACT_APP_API_URL}services/list`,
    });

  const handlePageChange = usePageChange(pagination, setPagination);

  useEffect(() => {
    fetchData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pagination.skip, pagination.limit]);

  const columns = [
    {
      title: "S.No",
      render: (text, record, index) => Number(pagination.skip || 0) + index + 1,
      fixed: "left",
      key: "serial",
      width: 80,
    },
    {
      title: "Service Category",
      key: "service_category",
      fixed: "left",
      width: 150,
      render: (_, record) => record.category?.service_category || "-",
    },
    {
      title: "Health Conditions",
      key: "health_conditions",
      width: 200,
      render: (_, record) =>
        record.category?.healthConditions
          ?.map((hc) => hc?.health_condition || "-")
          .filter(Boolean)
          .join(", "),
    },
    {
      title: "Cities",
      key: "cities",
      width: 200,
      render: (_, record) =>
        record.category?.cities
          ?.map((city) => city?.city || "-")
          .filter(Boolean)
          .join(", "),
    },
    {
      title: "Actions",
      key: "actions",
      render: (_, record) => (
        <>
          <Actions
            isDelete
            isEdit
            viewLabel="View Cities"
            onClickView={() =>
              navigate(
                `/web-bookings/${record.slug_url}/${record.category.slug_url}/view-cities`,
              )
            }
            onClickEdit={() =>
              navigate(
                `/web-bookings/${record.slug_url}/edit-service-category/${record.category.slug_url}`,
              )
            }
            onClickDelete={() => {
              setDeleteId(record); // ✅ use the category ID
              setShowDelete(true);
            }}
          />
          <Actions
            viewLabel="View Health Condition"
            onClickView={() =>
              navigate(
                `/web-bookings/${record.slug_url}/${record.category.slug_url}/view-health-conditions`,
              )
            }
          />
        </>
      ),
    },
  ];

  const dataSource = records.flatMap((record) => {
    if (!Array.isArray(record.categories) || record.categories.length === 0)
      return [];

    return record.categories.map((category, index) => ({
      ...record,
      key: `${record._id}_${index}`,
      category, // Keep category as a separate field for easy access
    }));
  });

  const breadcrumbsList = useMemo(
    () => [
      {
        text: "Web Bookings, Consultations & Appointments",
        link: "/web-bookings/home-healthcare-bookings",
      },
      // {
      //   text: servicesBreadcrumbs[0]?.name,
      //   link: `/web-bookings/${servicesBreadcrumbs[0]?.slug_url}`,
      // },
      {
        text: "View Service Category",
        link: "",
      },
    ],
    [],
  );

  return (
    <ListPageLayout
      breadcrumbs={
        <AntdBreadcrumbs
          className=" healthsyMasterBreadCrumbs"
          breadcrumbsList={breadcrumbsList}
        />
      }
      addButton={
        <FilledButton
          props={{
            id: "",
            label: "Add new Service Category",
            onClick: () =>
              navigate(
                "/web-bookings/home-healthcare-bookings/add-new-service-category",
              ),
          }}
        />
      }
      titles={<></>}
      tableProps={{
        columns,
        dataSource,
        className: "mx-3 pt-2 table-scrollable viewMed_table",
      }}
      totalCount={totalCount}
      pagination={pagination}
      onPageChange={(selected) => handlePageChange({ selected })}
    >
      {showDelete && (
        <Deletepopup
          handleDelete={async () =>
            await axios
              .delete(
                `${process.env.REACT_APP_API_URL}services/${deleteId.slug_url}/delete-service-category/${deleteId.category._id}`,
              )
              .then(() => {
                fetchData();
                setShowDelete(false);
              })
          }
          id={deleteId}
          handleClose={() => setShowDelete(false)}
        />
      )}
    </ListPageLayout>
  );
};

export default ViewServiceCategory;
